import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, Component, useRef } from "react"
import apiResponse from "../../../../services/apiResponse"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
} from "reactstrap"

import moment from "moment"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { Link } from 'react-router-dom'

import Select from "react-select"
import YearSelect from '../../../../helpers/ui/YearSelect';
import Shimmer from "react-shimmer-effect";

// import TableActiveComponent from './Components/TableActiveComponent'
import TableComponent from './Components/TableComponent'
// import IndexBloc from "./Blocs/IndexBloc"

const IndexView = (props) => {
    const activeRef = useRef();
    const inactiveRef = useRef();

    const reloadInactiveRef = () => inactiveRef.current.setTokenAPI()


    return (
        <Fragment>
            <Container fluid>
                <Card>
                    <CardBody>
                        <div className="float-end">
                        {
                            (accessRole('create')) ?
                                <Link to="?create">
                                    <Button color="primary">Tambah Periode Rapel</Button>
                                </Link>
                            : null
                        }
                        </div>
                        <CardTitle>Rapel</CardTitle>
                        <CardSubtitle className="mb-3">
                            {/* Daftar Urut Kepangkatan */}
                        </CardSubtitle>
                        <hr/>
                        <TableComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef}/>
                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    )
}

export default IndexView;